// extracted by mini-css-extract-plugin
export default {"menuItem":"item_menuItem__jBM3I","selected":"item_selected__i-1MX"};